interface AppConfig {
	googleAnalyticsKey?: string;
	sentryDsn?: string;
	debug?: string;
	assetUrl?: string;
	hubspotPortalId?: string;
	hubspotFormGuid?: string;
	apiUrl?: string;
	storageUrl?: string;
	easyAuthDev?: {
		clientId: string;
		authority: string;
		scope: string;
		redirectUri: string;
	};
	beta?: boolean;
	dev?: boolean;
	devServer?: boolean;
	version?: string;
	isApp?: boolean;
	isIOS?: boolean;
	isAndroid?: boolean;
	configCatKey?: string;
	config?: {
		socketUrl: string;
		adsEnabled: boolean;
		formsServiceUrl: string;
	};
}

let appConfig: AppConfig;
let configIsSet = false;

// A dev build bakes `localhost` into the API URL, which a phone on the same network resolves to itself.
export function resolveApiUrl(
	config: AppConfig,
	pageHostname: string = globalThis.location?.hostname ?? ''
): string | undefined {
	if (!config.devServer || !config.apiUrl) {
		return config.apiUrl;
	}

	let url: URL;

	try {
		url = new URL(config.apiUrl);
	} catch {
		return config.apiUrl;
	}

	if (url.hostname !== 'localhost' || !pageHostname || pageHostname === 'localhost') {
		return config.apiUrl;
	}

	url.hostname = pageHostname;

	return url.origin + url.pathname.replace(/\/$/, '');
}

export function setConfig(config: AppConfig): void {
	appConfig = { ...config, apiUrl: resolveApiUrl(config) };
	configIsSet = true;
}

export function getConfig(): AppConfig {
	if (!configIsSet) {
		throw new Error('config not set yet');
	}
	const defaultConfig: AppConfig = {
		googleAnalyticsKey: '',
		sentryDsn: '',
		debug: '',
		assetUrl: '',
		hubspotPortalId: '',
		hubspotFormGuid: '',
		apiUrl: '',
		version: '',
		config: {
			socketUrl: '',
			adsEnabled: false,
			formsServiceUrl: '',
		},
	};
	return appConfig || defaultConfig;
}

export function majorVersion(): number {
	const parts = getConfig().version?.split('.') ?? [];
	const ver = Number.parseInt(parts[0], 10);
	return Number.isNaN(ver) ? 0 : ver;
}

export function minorVersion(): number {
	const parts = getConfig().version?.split('.') ?? [];
	const ver = Number.parseInt(parts[1], 10);
	return Number.isNaN(ver) ? 0 : ver;
}

let isTesting = false;
export function setIsTesting(): void {
	isTesting = true;
}
export function isTest(): boolean {
	return isTesting;
}
